import React, { forwardRef } from "react";
import { cn } from "../../lib/utils";

const Button = forwardRef(
  ({ className, variant = "primary", size = "md", children, ...props }, ref) => {
    const variants = {
      primary: cn(
        "bg-gold text-ink font-semibold",
        "hover:bg-gold-dark",
        "shadow-md hover:shadow-gold",
        "border-2 border-gold-dark"
      ),
      secondary: cn(
        "bg-paper text-ink font-semibold",
        "border-2 border-ink",
        "hover:bg-ink hover:text-paper"
      ),
      outline: cn(
        "bg-transparent text-gold font-semibold",
        "border-2 border-gold",
        "hover:bg-gold hover:text-ink"
      ),
      ghost: cn(
        "bg-transparent text-ink font-medium",
        "hover:bg-paper-dark",
        "border-2 border-transparent"
      ),
    };

    const sizes = {
      sm: "h-9 px-4 text-sm",
      md: "h-11 px-6 text-base",
      lg: "h-14 px-8 text-lg",
    };

    return (
      <button
        ref={ref}
        className={cn(
          // Base styles
          "inline-flex items-center justify-center",
          "font-sans tracking-wide",
          "transition-all duration-300",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-paper",
          "disabled:pointer-events-none disabled:opacity-50",
          "active:scale-[0.98]",
          "cursor-pointer",
          // Variant and size
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = "Button";

export { Button };
